export const sortTemplates = (templates, sortBy) => {
	if (!Array.isArray(templates)) return [];

	if (sortBy === 'default') {
		return templates; // Return as-is (API default order)
	} else if (sortBy === 'newest') {
		return [...templates].sort((a, b) => new Date(b.date) - new Date(a.date));
	} else if (sortBy === 'popular') {
		return [...templates].sort((a, b) => (b.popular || 0) - (a.popular || 0));
	} else if (sortBy === 'title') {
		return [...templates].sort((a, b) => a.title.localeCompare(b.title));
	}

	return templates; // Fallback
};
